import angular from 'angular';
import { locationDecorator } from './angular';

/**
 * @ngdoc    overview
 * @name     csm.vendors
 * @description
 * Remove leading/trailing whitespace in template strings before processing.
 * With upgrading to jQuery 1.9.0, string templates with extra whitespace
 * will not be recognized as elements and cause errors.
 **/
export default angular
  .module('csm.vendors', [])
  .run(function () {
    /*--------------------------------*/
    /* Check is jQuery is being used. */
    /*--------------------------------*/
    if (window.jQuery) {
      /*--------------------------------------------------------*/
      /* Maintain a reference to the constructor init function. */
      /*--------------------------------------------------------*/
      var baseInit = jQuery.prototype.init;

      /*----------------------------------*/
      /* Override the base init function. */
      /*----------------------------------*/
      jQuery.prototype.init = function (selector, context, rootjQuery) {
        /*------------------------------------------------------*/
        /* Remove leading/trailing spaces from selector string. */
        /*------------------------------------------------------*/
        if (typeof selector === 'string') selector = selector.trim();

        /*---------------------------------------------------*/
        /* Call the base init function to finish processing. */
        /*---------------------------------------------------*/
        return baseInit.call(this, selector, context, rootjQuery);
      };

      /*-----------------------------------*/
      /* Give the init function the jQuery */
      /* prototype for later instantiation */
      /*-----------------------------------*/
      jQuery.prototype.init.prototype = jQuery.fn;
    }
  })
  .decorator('$location', locationDecorator).name;
